import { Dispatch, SetStateAction } from 'react'
import clsx from 'clsx'
import moment from 'moment'
import { Button, DateRangePicker, Modal, ModalProps } from 'components/common'

interface PeriodForSaleProps extends Omit<ModalProps, 'onOk'> {
  dates?: [moment.Moment, moment.Moment]
  loading?: boolean
  initialLoading?: boolean
  showEditTitle?: boolean
  onOk?: () => void
  onDateChange: Dispatch<SetStateAction<[moment.Moment, moment.Moment]>>
  resetPeriodForSale?: () => void
}

export const PeriodForSaleModal = ({
  dates,
  visible,
  onCancel,
  onOk,
  loading,
  initialLoading,
  onDateChange,
  resetPeriodForSale,
  showEditTitle = false,
  ...rest
}: PeriodForSaleProps) => {
  return (
    <>
      <Modal
        confirmLoading={loading}
        title={
          <p className="text-2xl font-bold m-0">
            {showEditTitle ? '販売期間を編集する' : '販売期間を追加する'}
          </p>
        }
        visible={visible}
        onCancel={onCancel}
        width="420px"
        footer={
          <div
            className={clsx(
              dates && showEditTitle ? 'flex justify-between m-2' : 'm-2'
            )}
          >
            {dates && showEditTitle && (
              <div>
                <Button
                  type="primary"
                  key="resetForm"
                  danger
                  loading={initialLoading}
                  onClick={resetPeriodForSale}
                  style={{ right: '0' }}
                >
                  販売期間を削除
                </Button>
              </div>
            )}

            <div>
              <Button onClick={onCancel}>キャンセル</Button>
              <Button
                disabled={!dates}
                type="primary"
                htmlType="submit"
                onClick={onOk}
              >
                追加
              </Button>
            </div>
          </div>
        }
        {...rest}
      >
        <div className="container">
          <DateRangePicker
            allowClear={false}
            style={{ width: '60%' }}
            picker="date"
            format="M月D日"
            value={dates || undefined}
            onChange={onDateChange}
          />
        </div>
      </Modal>
    </>
  )
}
